import styled, { css } from "styled-components";

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  backdrop-filter: none;
  background-color: rgb(0, 0, 0);
  width: 100%;
  transition: all 0.3s ease-in-out;
  transform: translateY(${(props) => (props.hide ? "-100%" : "0")});
  opacity: ${(props) => (props.hide ? "0" : "1")};
  z-index: 1000;
`;

export const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  height: 65px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    height: 50px;
  }
`;

export const Logo = styled.a`
  position: relative;
  width: 63px;
  height: 57px;
  display: block;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 40px;
    height: 37px;
  }
`;

export const LogoImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
`;

export const Nav = styled.nav`
  display: flex;
  gap: 40px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: #ccc;
  transition: color 0.3s cubic-bezier(0.44, 0, 0.56, 1) 0s;
  font-family: "Chakra Petch", sans-serif;
  font-size: 18px;

  &:hover {
    color: rgb(255, 98, 0);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  @media (max-width: 768px) {
    gap: 0.5rem;
    position: relative;
    z-index: 1001;
  }
`;

export const WhitePaperButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #000;
  border: 1px solid rgba(255, 131, 54, 0.73);
  border-radius: 10px;
  padding: 8px 16px;
  text-decoration: none;
  width: 199px;
  height: 45px;
  transition: all 0.3s cubic-bezier(0.44, 0, 0.56, 1);

  &:hover {
    border-color: #fff;
  }

  @media (max-width: 768px) {
    width: auto;
    height: 30px;
    padding: 5px 10px;
    border: none;
    transform: scale(1);
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const WhitePaperBackground = styled.div`
  position: relative;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 18px;
    width: 18px;
  }
`;

export const WhitePaperBackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const WhitePaperContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  text-align: center;
  color: #fff;
  line-height: 1.2;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const WhitePaperTitle = styled.p`
  font-family: "Gideon Roman", sans-serif;
  font-size: 14px;
`;

export const WhitePaperSubtitle = styled.p`
  font-family: "Gideon Roman", sans-serif;
  font-size: 16px;
`;

export const LanguageButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 1rem;

  &:hover,
  &:focus {
    color: #ffd700;
    outline: 2px solid #ffd700;
    outline-offset: 2px;
  }
`;

export const ScrollProgressBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${(props) => `${props.progress}%`};
  height: 0.5px;
  background-color: rgb(0, 255, 132);
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.hide ? "1" : "0")};
  z-index: 999;
`;

export const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
  position: relative;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 18px;
    height: 12px;
    margin-left: 10px;
  }

  span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #fff;
    transition: all 0.3s ease;
    position: absolute;

    &:nth-child(1) {
      top: ${({ isOpen }) => (isOpen ? "50%" : "0")};
      transform: ${({ isOpen }) => (isOpen ? "rotate(45deg)" : "none")};
    }

    &:nth-child(2) {
      top: 50%;
      transform: translateY(-50%);
      opacity: ${({ isOpen }) => (isOpen ? "0" : "1")};
    }

    &:nth-child(3) {
      bottom: ${({ isOpen }) => (isOpen ? "50%" : "0")};
      transform: ${({ isOpen }) => (isOpen ? "rotate(-45deg)" : "none")};
    }
  }

  &:hover {
    span {
      background-color: rgb(255, 98, 0);
    }
  }
`;

export const MobileNav = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  z-index: 1000;
  transform: translateX(${({ isOpen }) => (isOpen ? "0" : "100%")});
  transition: transform 0.3s ease;
  padding-top: 80px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const MobileNavLink = styled(NavLink)`
  font-size: 24px;
  margin: 20px 0;
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #ff4c00;
    text-decoration: none;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 24px;
    height: 2px;
    background-color: white;
    transition: all 0.3s ease;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &:hover {
    &::before,
    &::after {
      background-color: #ff4c00;
    }
  }
`;
